export const GET_ZPP_COURSE_INFOS_REQUEST = 'GET_ZPP_COURSE_INFOS_REQUEST';
export const GET_ZPP_COURSE_INFOS_SUCCESS = 'GET_ZPP_COURSE_INFOS_SUCCESS';
export const GET_ZPP_COURSE_INFOS_FAILURE = 'GET_ZPP_COURSE_INFOS_FAILURE';

export const getZppCourseInfosRequest = () => ({
  type: GET_ZPP_COURSE_INFOS_REQUEST
});

export const getZppCourseInfosFailure = (error) => ({
  type: GET_ZPP_COURSE_INFOS_FAILURE,
  error
});

export const getZppCourseInfosSuccess = ({ courseInfos }) => ({
  type: GET_ZPP_COURSE_INFOS_SUCCESS,
  payload: {
    courseInfos
  }
});
